setTimeout(function(){
        var primebText = document.getElementsByClassName('primebText');
        if(primebText[0]){
            for (var i = 0; i < primebText.length; i++) {
                var value = primebText[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primebText');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primebText');
                }
            }
        }
   
        var primehText = document.getElementsByClassName('primehTitle');
        if(primehText[0]){
            for (var i = 0; i < primehText.length; i++) {
                var value = primehText[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primehTitle');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primehTitle');
                }
            }
        }
        var primehsubText = document.getElementsByClassName('primehSubTitle');
        if(primehsubText[0]){
            for (var i = 0; i < primehsubText.length; i++) {
                var value = primehsubText[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primehSubTitle');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primehSubTitle');
                }
            }
        }

        var primebanTitle = document.getElementsByClassName('primebanTitle');
        if(primebanTitle[0]){
            for (var i = 0; i < primebanTitle.length; i++) {
                var value = primebanTitle[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primebanTitle');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primebanTitle');
                }
            }
        }
        var primebanSubTitle = document.getElementsByClassName('primebanSubTitle');
        if(primebanSubTitle[0]){
            for (var i = 0; i < primebanSubTitle.length; i++) {
                var value = primebanSubTitle[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primebanSubTitle');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primebanSubTitle');
                }
            }
        }

        var primetText = document.getElementsByClassName('primetText');
        if(primetText[0]){
            for (var i = 0; i < primetText.length; i++) {
                var value = primetText[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primetText');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primetText');
                }
            }
        }

        var primetHeader = document.getElementsByClassName('primetHeader');
        if(primetHeader[0]){
            for (var i = 0; i < primetHeader.length; i++) {
                var value = primetHeader[i].innerHTML;
                if( value.indexOf("CustomCountDown:") != -1  ){
                    customCountDownprime(value,i,'primetHeader');
                }
                if( value.indexOf("CustomCountDown2:") != -1  ){
                    customCountDown2prime(value,i,'primetHeader');
                }
            }
        }
   
    }, 1000);

    function customCountDownprime(newvalue,count,myclassname) {
        var primehText2 = document.getElementsByClassName(myclassname);
        var againvalue = newvalue;
        var pos3 = newvalue.indexOf("[[ CustomCountDown:");
        var pos4 = newvalue.indexOf(":");
        var pos5 = newvalue.indexOf(" ]]");
        var endres = againvalue.slice(pos3+19, pos5);
        var replacetext = againvalue.slice(pos3, pos5+3);
        newvalue = newvalue.replace("[[ CustomCountDown:", "" );
        newvalue = newvalue.replace(" ]]", "" );
        var setminutes = "minutes";
        var setseconds = "seconds";
        var x = setInterval(function() {
            let end = new Date();
            if(end.getHours() >= 14){
                primehText2[count].innerHTML = endres;
            }else{
                end.setHours(end.getHours() + 1,00,0);
                let start = new Date();
                var remaintime = end - start;
                var minutes = Math.floor((remaintime % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((remaintime % (1000 * 60)) / 1000);
                var realtimeleft = minutes +" "+ setminutes +" "+ seconds +" " + setseconds + " ";
                if(seconds < 0){
                    realtimeleft = setminutes+" 0 "+setseconds;
                }
                primehText2[count].innerHTML = newvalue.replace(endres,realtimeleft);
                primehText2[count].classList.remove("prime-counter");
                if (remaintime < 0) {
                    clearInterval(x);
                }
            }
        }, 1000);
    }



    function customCountDown2prime(newvalue,count,myclassname) {
        var primehText2 = document.getElementsByClassName(myclassname);
        var againvalue = newvalue;
        var pos3 = newvalue.indexOf("[[ CustomCountDown2:");
        var pos4 = newvalue.indexOf(":");
        var pos5 = newvalue.indexOf(" ]]");
        var endres = againvalue.slice(pos3+20, pos5);
        var replacetext = againvalue.slice(pos3, pos5+3);
        newvalue = newvalue.replace("[[ CustomCountDown2:", "" );
        newvalue = newvalue.replace(" ]]", "" );
        var sethours = "hours";
        var setminutes = "minutes";
        var setseconds = "seconds";
        var x = setInterval(function() {
            let end = new Date();
            if(end.getHours() >= 14){
                primehText2[count].innerHTML = endres;
            }else{
                end.setHours(14,00,0);
                let start = new Date();
                var remaintime = end - start;
                var hours = Math.floor((remaintime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((remaintime % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((remaintime % (1000 * 60)) / 1000);
                var realtimeleft = hours +" " + sethours +" "+ minutes +" "+ setminutes +" "+ seconds +" " + setseconds + " ";
                if(seconds < 0){
                    realtimeleft = setminutes+" 0 "+setseconds;
                }
                primehText2[count].innerHTML = newvalue.replace(endres,realtimeleft);
                primehText2[count].classList.remove("prime-counter");
                if (remaintime < 0) {
                    clearInterval(x);
                }
            }
        }, 1000);
    }